import type * as React from 'react';

import type * as api from '@gitbook/api-client';

import { ensureStackElements } from './ContentKitStack';
import type { ContentKitElementProps } from './types';

/**
 * Render the children of a configuration wrapper component.
 */
export function ContentKitConfiguration(
    props: ContentKitElementProps<api.ContentKitConfiguration>
): React.ReactElement {
    const { element, renderElement, renderElements } = props;

    if (isStepper(element.children)) {
        const stepper = element.children[0];
        return <>{renderElement(stepper, null, 'stepper')}</>;
    }

    if (areDescendantElements(element.children)) {
        return <>{renderElements('block', ensureStackElements('vstack', element.children))}</>;
    }

    throw new Error('Invalid configuration children');
}

/**
 * Type guard to determine if element.children is a single stepper element.
 */
function isStepper(
    children: api.ContentKitConfiguration['children']
): children is [api.ContentKitStepper] {
    return children.length === 1 && children[0].type === 'stepper';
}

/**
 * Type guard to determine if element.children is an array of descendant elements.
 */
function areDescendantElements(
    children: api.ContentKitConfiguration['children']
): children is api.ContentKitDescendantElement[] {
    return !children.some((child) => child.type === 'stepper');
}
